export enum AssessQueryKeys {
  assessmentsList = 'assessmentsList',
}

export enum OrganizationsQueryKeys {
  organizationsList = 'organizationsList',
}

export enum StandardsQueryKeys {
  standardsList = 'standardsList',
}

export enum AuthQueryKeys {
  callback = 'callback',
  exchangeCodeOnToken = 'exchangeCodeOnToken',
  verifyToken = 'verifyToken',
  refreshToken = 'refreshToken',
  getRoles = 'getRoles',
}

export enum GradeSheetsQueryKeys {
  gradeSheetsList = 'gradeSheetsList',
}

export enum FilesQueryKeys {
  minioFileDownload = 'minioFileDownload',
  downloadScoreView = 'downloadScoreView',
}

export enum ScoresQueryKeys {
  bsimmAssessmentView = 'bsimmAssessmentView',
  updateScoreForm = 'updateScoreForm',
  radarGraphView = 'radarGraphView',
  getScoresByAssessmentId = 'getScoresByAssessmentId',
}

export enum PopulationQueryKeys {
  bsimmControlsMappingUpload = 'bsimmControlsMappingUpload',
  verticalsList = 'verticalsList'
}